module.exports = __webpack_public_path__ + "img/kc-title-dark.2a34bcd7.png";